import React from "react";
import Transactions from "./Transactions";
import TransactionsV2 from "./TransactionsV2";

export default class Details extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeV2 = this.handleChangeV2.bind(this);
        this.state = {version: false};
    }
    handleChange() {
        this.setState({version: true});
    }
    handleChangeV2() {
        this.setState({version: false});
    }

    render() {
        return <div>
            <label style={styles.radio}>
                <input type="radio" name="option" value="V1" style={styles.radioButton} onChange={this.handleChange} checked={this.state.version === true} />
                V1
            </label>
            <label style={styles.radio}>
                <input type="radio" name="option" value="V2" style={styles.radioButton} onChange={this.handleChangeV2} checked={this.state.version === false}/>
                V2
            </label>
            {
                this.state.version
                    ? <Transactions env={this.props.env} compUpdate={this.props.compUpdate}></Transactions>
                    : <TransactionsV2 env={this.props.env} compUpdate={this.props.compUpdate}></TransactionsV2>
            }
        </div>;
    }
}

const styles = {
    radio: {
        marginRight: "10px",
        fontSize: "18px",
    },
    radioButton: {
        marginRight: "5px",
    },
};